import { startOfDay, parse, isBefore, isEqual, addDays, formatISO } from 'date-fns';
import { SEARCH_FORMAT_DATE } from './constants';

export const priceSavingFromItem = (item) => {
    if (!item) {
        return 0;
    }

    const tickets = (Array.isArray(item.tickets) ? item.tickets : [])
        .map((ticket) => ({
            price: parseFloat(ticket.price),
            strike: parseFloat(ticket.strike_out),
            booked: parseInt(ticket.booked, 10),
        }))
        .map((ticket) => ({
            price: ticket.price || 0,
            strike: ticket.strike || 0,
            booked: ticket.booked || 0,
        }));

    return tickets.reduce((acc, cur) => acc + cur.booked * (cur.strike - cur.price), 0);
};
export const priceSavingFromItems = (items) =>
    (Array.isArray(items) ? items : []).reduce((acc, cur) => acc + priceSavingFromItem(cur), 0);

export const stringNumberToBoolean = (value) => Boolean(parseInt(value));

export function convLocationQueryToDateTime(queryObject) {
    const { from, to } = queryObject;
    if (!from || typeof from !== 'string') {
        return { from: 0, to: 0 };
    }

    const currentDay = startOfDay(new Date());
    const fromDate = parse(from, SEARCH_FORMAT_DATE, 0);
    const toDate = parse(to, SEARCH_FORMAT_DATE, 0);

    if (isBefore(fromDate, currentDay)) {
        return { from: 0, to: 0 };
    }

    const fromTime = fromDate.getTime() || 0;
    let toTime = 0;
    if (fromTime) {
        toTime = isEqual(fromDate, toDate) ? toDate.getTime() : addDays(fromDate, 6).getTime();
    }

    return {
        from: fromTime,
        to: toTime,
    };
}

export function convStoredQueryToDateTime(queryObject) {
    const { from, to } = queryObject;
    if (!from || typeof from !== 'number') {
        return { from: 0, to: 0 };
    }

    const currentDay = startOfDay(new Date());
    const fromDate = new Date(from);
    const toDate = new Date(to);

    if (isBefore(fromDate, currentDay)) {
        return { from: 0, to: 0 };
    }

    const fromTime = fromDate.getTime() || 0;
    let toTime = 0;
    if (fromTime) {
        toTime = isEqual(fromDate, toDate) ? toDate.getTime() : addDays(fromDate, 6).getTime();
    }

    return {
        from: fromTime,
        to: toTime,
    };
}

export function getSearchDefauls() {
    const dateFrom = startOfDay(new Date());
    return {
        dateFrom: formatISO(dateFrom),
        dateTo: formatISO(addDays(dateFrom, 6)),
    };
}
